<div class="popup-container">
    <div class="popup-header">
        <h3 class="m-0">Colli già caricati</h3>
    </div>

    <div class="popup-body">
        <div class="alert alert-warning mb-3">
            <div class="fw-bold mb-2">
                <i class="fas fa-exclamation-triangle me-2"></i>Attenzione
            </div>
            <div class="mb-2" [innerHTML]="data.message"></div>
            <ul class="mb-0 ps-3 trip-groups-list">
                <li *ngFor="let group of data.tripGroups" [innerHTML]="group"></li>
            </ul>
            <ul class="mt-2 mb-0 ps-3 trip-groups-list" *ngIf="data.outcomes.length">
                <li *ngFor="let outcome of data.outcomes" [innerHTML]="outcome"></li>
            </ul>
        </div>

        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="openParcelsInTripDialog()">
            <i class="fas fa-info-circle me-1"></i> Info
        </button>
    </div>

    <div class="popup-footer d-flex justify-content-between gap-2">
        <button type="button" class="btn btn-light" (click)="cancel()">
            <i class="fas fa-times me-2"></i>
            No
        </button>

        <button type="button" class="btn btn-warning" (click)="confirm()">
            Togli dal viaggio e continua <i class="fas fa-arrow-right ms-2"></i>
        </button>
    </div>
</div>
